import { render, staticRenderFns } from "./AxisY.vue?vue&type=template&id=068e3718&"
import script from "./AxisY.vue?vue&type=script&lang=js&"
export * from "./AxisY.vue?vue&type=script&lang=js&"
import style0 from "./AxisY.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports